import styled from "styled-components";
import { type HeightProps, type WidthProps, height, width } from "styled-system";

export const EcoIcon = styled.span<{ url: string } & WidthProps & HeightProps>`
    display: inline-block;
    background-image: url(${({ url }) => url});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    ${width};
    ${height};
`;

export const Wrapper = styled.span`
    display: inline-flex;
    column-gap: var(--spacing-1);
    align-items: center;

    @supports not (gap: var(--spacing-1)) {
        ${EcoIcon} {
            margin-left: var(--spacing-1);
        }
    }
`;
